export default {
  title: 'Rezervări CSV',
  buttons: {
    generate: 'Generează și descarcă',
  },
  fields: {
    date_range: 'Interval de date (opțional)',
  },
  errors: {
    invalid_date_range: 'Selectați un interval de date valid',
  },
};
